import React, { useEffect, useRef, useState } from 'react';
import "./messages_styles/messagespage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faMagnifyingGlass,
    faBarsStaggered,
    // faStar,
    faPaperPlane,
    faPaperclip,
    faCheck,
    faCheckDouble
} from "@fortawesome/free-solid-svg-icons";
import ChatProfileCard from './ChatProfileCard';
import { chatsRef, chatRoomsRef, usersRef, serverTimestamp } from '../../firebase';
import { useSelector } from 'react-redux';
import LoadingPage from '../LoadingPage';
import Swal from 'sweetalert2';
import { getUsersCollectionIds } from '../../App';
import notificationSound from '../../audios/msg_notify.mp3';


const MessagesPage = () => {
    const [chatMenuBar, setChatMenuBar] = useState("");
    const [chatRooms, setChatRooms] = useState([]);     // showing all users in left side
    const [chatRoomId, setChatRoomId] = useState('');   //  after click on user(chat with person email id) to chat (helps to fetch chat data)
    const [chatRoomData, setChatRoomData] = useState([]);   //  chat data after click on user
    const [chatWithPersonData, setChatWithPersonData] = useState([]);
    const [isChatRoomLoading, setIsChatRoomLoading] = useState(true);
    const [isChatDataLoading, setIsChatDataLoading] = useState(true);
    const [message, setMessage] = useState("");
    const chatContainerRef = useRef(null);
    const [unseenMsgCountData, setUnseenMsgCountData] = useState(new Map());
    const usersData = useSelector((state) => state.userData);

    const handleChatMenuBar = () => {
        if (chatMenuBar === '') {
            setChatMenuBar('chat_menu_close');
        } else {
            setChatMenuBar('');
        }
    }

    const handleChatMenuBarMobileView = () => {
        if (chatMenuBar === '') {
            setChatMenuBar('chat_menu_close');
        } else {
            setChatMenuBar('');
        }
    }


    //  After clicking on a user(chatRoom) that code will run
    const handleActiveChatUser = (chatWithData) => {
        // console.log("handleActiveChatUser clicked -> ", chatWithData.data.chat_with_person);
        if (chatRoomId === chatWithData.data.chat_with_person) {
            return;
        }
        setIsChatDataLoading(true);
        setChatRoomId(chatWithData.data.chat_with_person);
        setChatWithPersonData([]);
        setChatWithPersonData([chatWithData]);
    }


    //  Chat msg sent function
    const handleSendMessage = async () => {
        // Code to send the message goes here
        // console.log("Message sent:", message);
        chatsRef.add({
            from_msg: usersData.email,
            msg: message,
            status: "unseen",
            time: serverTimestamp,
            to_msg: chatRoomId,
        })
        setMessage("");
        const chatRoomSnapshot1 = await chatRoomsRef
            .where("user", "==", usersData.email)
            .where("chat_with_person", "==", chatRoomId)
            .get();
        if (!chatRoomSnapshot1.empty) {
            const chatRoomDoc = chatRoomSnapshot1.docs[0];
            await chatRoomDoc.ref.update({ last_msg_time: serverTimestamp, last_msg: message});
        }
        const chatRoomSnapshot2 = await chatRoomsRef
            .where("user", "==", chatRoomId)
            .where("chat_with_person", "==", usersData.email)
            .get();
        if (!chatRoomSnapshot2.empty) {
            const chatRoomDoc = chatRoomSnapshot2.docs[0];
            await chatRoomDoc.ref.update({ last_msg_time: serverTimestamp, last_msg: message});
        }
    };


    // Add new conversation (new chatRoom)
    const handleAddConversation = async (usersData, chatRooms, setChatRooms) => {
        const { value: email } = await Swal.fire({
            title: 'Add New Conversation',
            input: 'email',
            inputLabel: 'Enter Email Address',
            inputPlaceholder: 'Email Address',
            showCancelButton: true
        })
        if (email) {
            const chatRoomsIds = chatRooms.map((data) => data.user.email);
            if (chatRoomsIds.includes(email)) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Already Present!',
                })
            }
            else if (email === usersData.email) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Can not send msg to yourself!',
                })
            }
            else {
                const signedIn_email_ids = await getUsersCollectionIds();
                if (signedIn_email_ids.includes(email)) {
                    // add to chatRoomsRef
                    await chatRoomsRef.add({
                        last_msg: "",
                        last_msg_time: serverTimestamp,
                        user: usersData.email,
                        chat_with_person: email
                    }).then(() => {
                        chatRoomsRef.add({
                            last_msg: "",
                            last_msg_time: serverTimestamp,
                            user: email,
                            chat_with_person: usersData.email
                        })
                    }).then(() => {
                        Swal.fire({
                            icon: 'success',
                            title: 'New Conversation is added',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        // fetch updated chat rooms data
                        fetchChatRooms(usersData, (result) => {
                            setChatRooms(result);
                        });
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'User is not present in this platform!',
                    })
                }
            }
        }
    }


    // fetch all chat rooms(user) - also fetch user data to render chat room
    const fetchChatRooms = (usersData, callback) => {
        chatRoomsRef
            .where('user', '==', usersData.email)
            .onSnapshot(async (snapshot) => {
                const fetchedChatRoomData = snapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                }));
                const sortedChatRooms = fetchedChatRoomData.sort((a, b) => {
                    const aTime = a?.data?.last_msg_time?.seconds || 0;
                    const bTime = b?.data?.last_msg_time?.seconds || 0;
                    return bTime - aTime;
                });
                const sortedChatRooms_with_userData = [];
                for (const x of sortedChatRooms) {
                    // fetch user data to render chat room
                    const userDoc = await usersRef.doc(x.data.chat_with_person).get();
                    const user = userDoc.exists ? userDoc.data() : null;
                    sortedChatRooms_with_userData.push({ ...x, user });
                }
                callback(sortedChatRooms_with_userData);
            });
    };


    // fetch all chat rooms (users)
    useEffect(() => {
        fetchChatRooms(usersData, (result) => {
            setChatRooms(result);
            setIsChatRoomLoading(false);
        })
        // eslint-disable-next-line
    }, [usersData.email, chatRoomId]);


    // Fetch unseen message count data 
    useEffect(() => {
        const unsubscribe = chatsRef
            .where('to_msg', '==', usersData.email)
            .where('status', '==', 'unseen')
            .onSnapshot(snapshot => {
                const msgCountData = new Map();
                const data = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }));
                // console.log(data);
                data.forEach((d) => {
                    const count = msgCountData.get(d.data.from_msg) || 0;
                    msgCountData.set(d.data.from_msg, count + 1);
                });
                // console.log(msgCountData);
                setUnseenMsgCountData(msgCountData);
            });
        return () => {
            unsubscribe();
        };
        // eslint-disable-next-line
    }, [chatRooms]);


    // notification sound play
    useEffect(() => {
        if (unseenMsgCountData.size > 0) {
            const audio = new Audio(notificationSound);
            audio.play();
        }
    }, [unseenMsgCountData]);


    // fetch chat data with a user
    useEffect(() => {
        if (chatRoomId.length === 0) {
            return;
        }
        let data1 = [];
        let data2 = [];
        const unsubscribe1 = chatsRef
            .where('from_msg', '==', usersData.email)
            .where('to_msg', '==', chatRoomId)
            .onSnapshot(snapshot => {
                data1 = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }));
                // console.log(data1)
                const sortedChatRoomData = [...data1, ...data2].sort((a, b) => {
                    const aDate = a.data.time ? new Date(a.data.time.seconds * 1000 + a.data.time.nanoseconds / 1000000) : new Date();
                    const bDate = b.data.time ? new Date(b.data.time.seconds * 1000 + b.data.time.nanoseconds / 1000000) : new Date();
                    return aDate - bDate;
                });
                setChatRoomData(sortedChatRoomData);
            });

        const unsubscribe2 = chatsRef
            .where('from_msg', '==', chatRoomId)
            .where('to_msg', '==', usersData.email)
            .onSnapshot(snapshot => {
                data2 = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }));
                const sortedChatRoomData = [...data1, ...data2].sort((a, b) => {
                    const aDate = a.data.time ? new Date(a.data.time.seconds * 1000 + a.data.time.nanoseconds / 1000000) : new Date();
                    const bDate = b.data.time ? new Date(b.data.time.seconds * 1000 + b.data.time.nanoseconds / 1000000) : new Date();
                    return aDate - bDate;
                });
                setChatRoomData(sortedChatRoomData);
                setIsChatDataLoading(false);

                // Update status of the messages to "seen"
                snapshot.docs.forEach(doc => {
                    const data = doc.data();
                    if (data.from_msg === chatRoomId && data.status === 'unseen') {
                        chatsRef.doc(doc.id).update({ status: 'seen' });
                    }
                });

            });

        return () => {
            unsubscribe1();
            unsubscribe2();
        };
        // eslint-disable-next-line
    }, [chatRoomId]);

    const inputEvent = (event) => {
        let { value } = event.target;
        setMessage(value);
    }

    // Scroll to the bottom of the chat container
    useEffect(() => {
        const scrollToBottom = () => {
            chatContainerRef.current?.scrollIntoView({ behavior: "smooth" })
        }
        scrollToBottom();
    }, [chatRoomData]);


    // console.log("chatRooms->", chatRooms)
    // console.log(isChatDataLoading);
    // console.log("unseenMsgCountData-->", unseenMsgCountData);


    return (
        <>
            <div className={`messagespage_container ${chatMenuBar}`}>
                <div className='messages_sidebar' >
                    <div className='chat_sticky_container'>
                        <div className='message_header_container'>
                            <div className='message_header'>
                                <h2 className='task_title'>Conversations</h2>
                                <span className='unread_message_count' style={{ display: unseenMsgCountData.size ? "" : "none" }}>{unseenMsgCountData.size}</span>
                            </div>
                            <div className='message_menu_bar'>
                                <FontAwesomeIcon icon={faBarsStaggered} className='chat_menu' onClick={handleChatMenuBarMobileView} />
                            </div>
                        </div>
                        <div className='oprions_box'>
                            <button className='option active_option' onClick={() => handleAddConversation(usersData, chatRooms, setChatRooms)}>Add Conversations</button>
                        </div>
                        <div className='message_search_container'>
                            <FontAwesomeIcon icon={faMagnifyingGlass} className='search_icon' />
                            <input placeholder='Search Conversations' className='search_box' />
                        </div>
                    </div>
                    <div className='messages_people_container'>
                        {
                            isChatRoomLoading ? <LoadingPage /> :
                                chatRooms.map((data) => {
                                    return (
                                        <ChatProfileCard key={data.id} props={data} unseenMsgCountData={unseenMsgCountData} onClick={() => handleActiveChatUser(data)} />
                                    );
                                })
                        }
                    </div>
                </div>
                <div className='messages_rightbar'>
                    <div className='chat_nav'>
                        <FontAwesomeIcon icon={faBarsStaggered} className='chat_menu' onClick={handleChatMenuBar} />
                        <div><h2 className='chat_room'>{chatWithPersonData.length === 1 ? chatWithPersonData[0].user.displayName : ''}</h2></div>
                    </div>
                    <div className='chat_container'>
                        {
                            chatWithPersonData.length === 0 ? "Select user for Chatting" :
                                isChatDataLoading ? <LoadingPage /> :
                                    chatRoomData.map((roomData) => {
                                        // console.log(roomData.data.time.seconds);
                                        return (
                                            <div className={`chat ${roomData.data.from_msg === usersData.email ? 'your_chat' : ''}`} key={roomData.id}>
                                                <img src={roomData.data.from_msg === usersData.email ? usersData.profileImage_path : chatWithPersonData[0].user.profileImage_path}
                                                    alt="profile_image" height="40px" width="40px" className="profileLogo" />
                                                <div className='msg'>
                                                    <span className='chat_msg'>{roomData.data.msg}</span>
                                                    <div className='chat_footer'>
                                                        <span className='chat_time'>{roomData.data.time ? new Date(roomData.data.time.seconds * 1000).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' }) : `Just Now`}</span>
                                                        <span className='chat_sent_seen'>
                                                            {
                                                                roomData.data.status === "seen" ?
                                                                    <FontAwesomeIcon icon={faCheckDouble} className='chat_seen' /> :
                                                                    <FontAwesomeIcon icon={faCheck} className='chat_seen' />
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                        }
                    </div>
                    <div ref={chatContainerRef} />
                    <div className='chat_input_container' style={{ display: chatWithPersonData.length === 1 ? '' : 'none' }}>
                        <input className='chat_input_box' placeholder='Type your message' value={message}
                            onChange={inputEvent} name="message" autoComplete="off"
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleSendMessage();
                                }
                            }}
                        />
                        <FontAwesomeIcon icon={faPaperclip} className='chat_sent_icon' />
                        <FontAwesomeIcon icon={faPaperPlane} className='chat_sent_icon' onClick={() => handleSendMessage()} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default MessagesPage